<template>
    <div id="step1">
        <a-row>
            <a-row>
                <p @click="() => (isForm = !isForm)" style="font-size: 13px;font-weight: 800;margin-left: 16px;"
                    class="sbxs mt4">Query Condition
                    <a-icon :type="isForm ? 'caret-up': 'caret-down'" />
                </p>
                <a-form :form="form" v-show="isForm" style="margin-right: 4px;">
                    <a-row>
                        <a-col :span="8">
                            <a-form-item label="SKU" v-bind="formItemLayout">
                                <a-input autocomplete="off" style="width: 100%;" size="small"
                                    :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['sku']" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="Style" v-bind="formItemLayout">
                                <a-input autocomplete="off" style="width: 100%;" size="small"
                                    :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['style']" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="Location" v-bind="formItemLayout">
                                <a-input autocomplete="off" style="width: 100%;" size="small"
                                    :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['location']" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="Barcode" v-bind="formItemLayout">
                                <a-input autocomplete="off" style="width: 100%;" size="small"
                                    :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['barcode']" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="Receive Date From" v-bind="formItemLayout">
                                <a-date-picker size="small" style="width: 100%;" v-decorator="['dateFm']" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="Receive Date To" v-bind="formItemLayout">
                                <a-date-picker size="small" style="width: 100%;" v-decorator="['dateTo']" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item :label=dudfData.DUDF_01 v-bind="formItemLayout">
                                <a-input autocomplete="off" style="width: 100%;" size="small"
                                    :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['dudf01']" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item :label=dudfData.DUDF_02 v-bind="formItemLayout">
                                <a-input autocomplete="off" style="width: 100%;" size="small"
                                    :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['dudf02']" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item :label=dudfData.DUDF_03 v-bind="formItemLayout">
                                <a-input autocomplete="off" style="width: 100%;" size="small"
                                    :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['dudf03']" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
                <a-row type="flex" justify="end" class="mtb8">
                    <a-col>
                        <a-button type="danger" size="small" @click="clearFrom">Clear</a-button>
                    </a-col>
                    <a-col class="ml4">
                        <a-button type="primary" size="small" @click="searchTable" style="margin-right: 4px;">
                            <img src="../../../../assets/img/Liqutor-search.png" width="13" height="12"
                                class="mr4" />Search
                        </a-button>
                    </a-col>
                </a-row>
            </a-row>
            <a-spin :spinning="spinning">
                <a-row type="flex" justify="space-between" class="paddingLeftRight"
                    style="font-weight: 800;color: #ababab;font-size: 14px;margin-left: 27px;">
                    <a-col>Inventory</a-col>
                    <a-col>
                        <a-row type="flex" justify="start">
                            <a-col>
                                Total: {{totalRecords}} records
                            </a-col>
                            <a-col>
                                <a-icon type="left" :style="{ cursor: pageNum == 1 ? 'not-allowed': 'pointer'}"
                                    @click="pageInit('l')" />
                                <a-input size="small" v-model="pageNum"
                                    style="width: 33px;text-align: center;font-size: 12px;margin: 0 4px"
                                    @pressEnter="pressEnter" />
                                <a-icon type="right" class="sbxs" @click="pageInit('r')"
                                    :style="{ cursor: pageNum == totalFeshu ? 'not-allowed': 'pointer'}" />
                                <a-dropdown placement="bottomCenter" @click="pageSizeChange">
                                    <a-button size="small">{{pageSize}} / Page
                                        <a-icon type="down" style="font-size: 12px;" />
                                    </a-button>
                                    <a-menu slot="overlay" @click="pageSizeChange">
                                        <a-menu-item key="10">10 / Page</a-menu-item>
                                        <a-menu-item key="20">20 / Page</a-menu-item>
                                        <a-menu-item key="30">30 / Page</a-menu-item>
                                        <a-menu-item key="40">40 / Page</a-menu-item>
                                        <a-menu-item key="100">100 / Page</a-menu-item>
                                        <a-menu-item key="500">500 / Page</a-menu-item>
                                        <a-menu-item key="1000">1000 / Page</a-menu-item>
                                    </a-menu>
                                </a-dropdown>
                                <a-badge
                                    :count="cartQty"
                                    class="mllr4">
                                    <img src="../../../../assets/img/gouwu2.png" width="23" height="23" class="sbxs"
                                        @click="gowuTotal">
                                </a-badge>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
                <a-row style="height: 55vh;overflow-y: auto;float:left;width: 1180px;">
                    <a-row v-if="tableList.length == 0"
                        style="display: flex;justify-content: center;align-items: center;height: 100%;">
                        <a-empty />
                    </a-row>
                    <a-row v-else type="flex" class="list_Liquor" v-for="(item,index) in tableList">
                        <a-col class="sbxs" @click="enlargeImgs(index)" style="float: left;width: 130px;height: 130px;border: 1px solid #B8B8B8;">
                            <template class="block">
                                <img v-if="item.mainPhoto != null" :src="item.mainPhoto" style="max-width: 128px;max-height: 128px;display: block;margin: auto;position: absolute;margin: auto;top: 0;left: 0;right: 0;bottom: 0;">
                                <img v-else src="../../../../assets/img/noImage.png" style="max-width: 128px;max-height: 128px;display: block;margin: auto;top: 0;left: 0;right: 0;bottom: 0;">
                            </template>
                        </a-col>
                        <a-col style="float: left;width: 1020px;margin-left: 5px;">
                            <a-row type="flex" style="text-align: center;font-weight: bold;">
                                <a-col style="width: 660px;text-align: left;">
                                    <a-col style="font-size: 20px;">{{item.sku}}</a-col>
                                    <a-col style="font-weight: normal;font-size: 17px;">{{item.skuDes}}</a-col>
                                </a-col>
                                <a-col style="width: 120px;">
                                    <a-row>UOM</a-row>
                                    <a-row>{{item.skuUom}}</a-row>
                                </a-col>
                                <a-col style="width: 140px;">
                                    <a-col class='list_Liquor_title'>Available/On Hand</a-col>
                                    <a-col style="height: 33px;">{{item.sumAvBaseQty}}/{{item.sumOnHandQty}}</a-col>
                                </a-col>
                                <a-col style="width: 100px;">
                                    <a-col class='list_Liquor_title'>Order Qty</a-col>
                                    <a-col style="height: 33px">
                                            <a-input-number :formatter="value => `$ ${value}`.replace(/^(0+)|[^\d]/g, '')"
                                                        :parser="value => value.replace(/^(0+)|[^\d]/g, '')"
                                                        :min="0" size="small" style="width: 60px;"
                                                        v-model="item.sumOrderQty" @change="changeDetailQty(item)" />
                                            <i class="el-icon-delete" style="font-size: 20px;margin-top: 3px;cursor: pointer"
                                               @click="clearSumOrderQty(item)"></i>
                                        <!--<a-col>{{item.sumOrderQty}}</a-col>-->
                                    </a-col>
                                </a-col>
                            </a-row>
                            <el-collapse-transition>
                                <a-row v-show="item.showDetail" style="margin-left: 10px;" type="flex" justify="space-between">
                                    <a-row type="flex" justify="space-between"
                                           style="font-weight: bold;text-align: left;">
                                        <a-col style="width: 200px;">{{dudfData.DUDF_01}}</a-col>
                                        <a-col style="width: 100px;">{{dudfData.DUDF_02}}</a-col>
                                        <a-col style="width: 200px;">{{dudfData.DUDF_03}}</a-col>
                                        <a-col style="width: 30px;"></a-col>
                                        <a-col style="width: 120px;">Location</a-col>
                                        <a-col style="width: 120px;">Barcode</a-col>
                                        <a-col style="width: 140px;"></a-col>
                                        <a-col style="width: 100px;"></a-col>
                                    </a-row>
                                    <a-row type="flex" justify="space-between" style="text-align: center;"
                                           v-for="(ite,index2) in item.invNonMerDudfList">
                                        <a-row type="flex" justify="space-between" style="text-align: left;"
                                               v-for="(detail,index3) in ite.skuOrderData">
                                            <a-col style="width: 200px;">{{index3 > 0 ? '' : ite.dudf01}}</a-col>
                                            <a-col style="width: 100px;">{{index3 > 0 ? '' : ite.dudf02}}</a-col>
                                            <a-col style="width: 200px;">{{index3 > 0 ? '' : ite.dudf03}}</a-col>
                                            <a-col style="width: 30px;">
                                                <i class="el-icon-picture-outline" style="font-size: 20px;cursor: pointer;" @click="enlargeImg(detail.imageUrl)"></i>
                                            </a-col>
                                            <a-col style="width: 120px;">{{detail.locationCode}}</a-col>
                                            <a-col style="width: 120px;">{{detail.barcode}}</a-col>
                                            <a-col style="width: 140px;text-align: center;padding-right: 5px;">{{parseInt(detail.avBaseQty)}}/{{parseInt(detail.onHandQty)}}</a-col>
                                            <a-col style="width: 100px;text-align: center;">
                                                <a-input-number :formatter="value => `$ ${value}`.replace(/^(0+)|[^\d]/g, '')"
                                                                :parser="value => value.replace(/^(0+)|[^\d]/g, '')"
                                                                ref="orderQtyinputNumberRefs" :min="0" size="small" style="width: 60px;"
                                                                v-model="detail.orderQty" @change="changeOrderQty(item)" />
                                                <i class="el-icon-delete" style="font-size: 20px;margin-top: 3px;cursor: pointer"
                                                   @click="item.sumOrderQty = item.sumOrderQty - detail.orderQty,detail.orderQty = 0"></i>
                                            </a-col>
                                        </a-row>
                                        <a-divider style="margin: 10px 0 0 0"></a-divider>
                                    </a-row>
                                </a-row>
                            </el-collapse-transition>
                            <a-row type="flex" justify="space-between" style="">
                                <a-col span="17" style="margin-top: 15px;">
<!--                                    <a-col>UOM: {{item.skuUom}}</a-col>-->
                                </a-col>
                                <a-col span="3" style="margin-top: 15px;">
                                    <a-col @click="item.showDetail = !item.showDetail">
                                        <i v-if="!item.showDetail" class="el-icon-caret-bottom" style="font-size: 20px;cursor: pointer;"></i>
                                        <i v-else class="el-icon-caret-top" style="font-size: 20px;cursor: pointer;"></i>
                                        <span style="cursor: pointer;" v-if="!item.showDetail">Show Breakdown</span>
                                        <span style="cursor: pointer;" v-else>Hide Breakdown</span>
                                    </a-col>
                                </a-col>
                                <a-col style="margin-top: 5px">
                                    <el-button plain @click="itemGoshopDetail3(item)">
                                        <img src="../../../../assets/img/gouwu2.png" width="23" height="23" style="margin: -20px 0"
                                            class="sbxs">Add to cart
                                    </el-button>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-row>
            </a-spin>
            <div style="height: 45px;"></div>
        </a-row>
        <div :style="{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              zIndex: 1}">
            <a-button class="fl" type="primary" size="small" style="visibility: hidden"><img
                    src="../../../../assets/img/Liqutor-left.png" width="13" height="12" class="mr4">Previous</a-button>
            <a-button @click='goTypeClick("Next")' class="fr" type="primary" size="small"><img
                    src="../../../../assets/img/Liqutor-arrow-right.png" width="13" height="12" class="mr4">Next
            </a-button>
            <div style="text-align: center">
                <a-button style="visibility: hidden" type="primary" size="small" @click="stepSave"><img
                        src="../../../../assets/img/Liqutor-save.png" width="13" height="12" class="mr4">Save</a-button>
                <a-button v-if="false" @click="resetStep" style='margin-left: 40px;' type="danger" size="small"><img
                        src="../../../../assets/img/Liqutor-refresh.png" width="13" height="12" class="mr4">Reset
                </a-button>
            </div>
        </div>

        <a-modal :visible="bigImgvis" v-if="bigImgUrl != null && bigImgUrl.split(',').length > 0" :footer="null" width="1100px" @cancel="() => (bigImgvis = !bigImgvis && bigImgUrl == '')">
            <template class="block">
                <el-carousel height="600px" style="width: 1100px;">
                    <el-carousel-item v-for="(item,index) in bigImgUrl.split(',')">
                        <img v-if="item != ''" :src="item" style="max-width: 1100px;max-height: 700px;display: block;position: absolute;margin: auto;top: 0;left: 0;right: 0;bottom: 0;">
                        <img v-else src="../../../../assets/img/noImage.png" style="max-width: 1100px;max-height: 700px;display: block;position: absolute;margin: auto;top: 0;left: 0;right: 0;bottom: 0;">
                    </el-carousel-item>
                </el-carousel>
            </template>
        </a-modal>

        <a-modal :visible="bigImgs" :footer="null" width="1100px" @cancel="() => (bigImgs = !bigImgs)">
            <template class="block" v-if="tableList.length > 0 && tableList[bigImgIndex] != null && tableList[bigImgIndex].invNonMerDudfList[0] != null && tableList[bigImgIndex].invNonMerDudfList[0].skuOrderData.length > 0">
                <el-carousel height="600px" style="width: 1100px;" v-for="(item,index) in tableList[bigImgIndex].invNonMerDudfList">
                    <el-carousel-item v-if="index == 0">
                        <img :src="tableList[bigImgIndex].mainPhoto" style="max-width: 1100px;max-height: 700px;display: block;position: absolute;margin: auto;top: 0;left: 0;right: 0;bottom: 0;">
                    </el-carousel-item>
                    <template v-for="item2 in item.skuOrderData">
                        <template v-if="item2.imageUrl != null">
                            <el-carousel-item v-for="item3 in item2.imageUrl.split(',')">
                                <img v-if="item3 != ''" :src="item3" style="max-width: 1100px;max-height: 700px;display: block;position: absolute;margin: auto;top: 0;left: 0;right: 0;bottom: 0;">
                                <img v-else src="../../../../assets/img/noImage.png" style="max-width: 1100px;max-height: 700px;display: block;position: absolute;margin: auto;top: 0;left: 0;right: 0;bottom: 0;">
                            </el-carousel-item>
                        </template>
                    </template>
                </el-carousel>
            </template>
        </a-modal>

    </div>
</template>
<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    import moment from "moment";
    import Template from "../../reportCom/template";
    import store from "../../../../store";
    export default {
        components: {
            Template,
        },
        props: {

            nonMerOrder: { // 父组件传进来的 所有这单临时数据
                type: Object,
                default: function () {
                    return {};
                }
            },





            sellLiquor: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            stepSelectData: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            initCloseValue: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            dudfData: {
                type: Object,
                default: function () {
                    return {};
                }
            },
        },
        data() {
            return {
                isForm: true,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                form: this.$form.createForm(this),
                tableList: [],
                targetImgBig: {},
                rightBigImg: null,

                formItemLayout: {
                    labelCol: {
                        xs: {
                            span: 24
                        },
                        sm: {
                            span: 8
                        }
                    },
                    wrapperCol: {
                        xs: {
                            span: 24
                        },
                        sm: {
                            span: 16
                        }
                    }
                },
                bigImgvis: false,
                bigImgUrl:"",
                bigImgs: false,
                bigImgIndex:0,
                pageNum: 1,
                pageSize: 30,
                searchInfo: {},
                totalFeshu: 0,
                targetPageNum: 0,
                gouwucheData: [], //总的购物车的数据
                skuInv: [],
                spinning: false, // 搜索加下提示
                groupByDudf123: "", //根据Dudf1,2,3分组,Dudf1,2,3列只显示第一次,然后底部添加横线
                totalRecords:0,
                cartQty:0,
            }
        },
        created() {
            //  绑定回车事件
            let that = this
            document.onkeydown = function (e) {
                let key = window.event.keyCode;
                if (key == 13) {
                    that.searchTable()
                }
            }
            // 查询inv table
            that.searchTable()
            console.info("刷新列表")

        },
        methods: {
            changeOrderQty(item) {
                let sumOrderQty = 0;
                for (let skuInv2 of item.invNonMerDudfList) {
                    for (let skuInv of skuInv2.skuOrderData) {
                        let qty = skuInv.orderQty == null || skuInv.orderQty == '' ? 0 : skuInv.orderQty;
                        sumOrderQty += qty;
                    }
                }
                item.sumOrderQty = sumOrderQty;
            },
            changeDetailQty(item) {
                let sumOrderQty = item.sumOrderQty == null || item.sumOrderQty == '' ? 0 : item.sumOrderQty;
                if (sumOrderQty > item.sumAvBaseQty) {
                    this.$message.error("Order Qty can not exceed the available Qty");
                }
                for (let skuInv2 of item.invNonMerDudfList) {
                    for (let skuInv of skuInv2.skuOrderData) {
                        if (sumOrderQty >= skuInv.avBaseQty) {
                            skuInv.orderQty = skuInv.avBaseQty;
                            sumOrderQty -= skuInv.avBaseQty;
                        } else {
                            skuInv.orderQty = sumOrderQty;
                            sumOrderQty = 0;
                        }
                    }
                }
            },
            clearSumOrderQty(item) {
                item.sumOrderQty = 0;
                for (let skuInv2 of item.invNonMerDudfList) {
                    for (let skuInv of skuInv2.skuOrderData) {
                        skuInv.orderQty = 0;
                    }
                }
            },
            //            下拉选择也去search
            remarkChangeAjax(val) {

                this.searchInfo.itemRemark = val
                this.init()
            },
            //            清除表单内容
            clearFrom() {
                this.form.resetFields();
                this.searchInfo = {}
                this.init()
            },
            gowuTotal() {
                this.$emit('goType', 'Next')
            },
            addToCart() {

                console.info(detail)
            },
            itemGoshopDetail3(item) {
                // 1. 获取购物车已存在的数据
                let nonMerOrderDetails = this.nonMerOrder.nonMerOrderDetails

                let newNonMerOrderDetails = [];
                let invList = item.invNonMerDudfList;
                for (let inv2 of invList) {
                    for (let inv of inv2.skuOrderData) {
                        let orderQty = inv.orderQty
                        if (orderQty == null || orderQty == 0) {
                            continue;
                        }
                        let sumOrderQty = inv.orderQty
                        // 检查购物车数量和新加的数量是否超
                        if (nonMerOrderDetails != undefined && nonMerOrderDetails != null) {
                            for (let nonMerOrderDetail of nonMerOrderDetails) {
                                if (item.sku == nonMerOrderDetail.sku && item.skuUom == nonMerOrderDetail.skuUom) {

                                    let skuOrderDatas = nonMerOrderDetail.skuOrderData;

                                    for (let detail of skuOrderDatas) {
                                        if (inv.dudf01 == detail.dudf01 && inv.dudf02 == detail.dudf02 && inv.dudf03 == detail.dudf03 && inv.locationCode == detail.locationCode && inv.lotId == detail.lotId) {
                                            sumOrderQty += detail.orderQty
                                        }
                                    }
                                }
                            }
                        }

                        let avBaseQty = inv.avBaseQty
                        if (sumOrderQty > avBaseQty) { // 数量超过可用数量
                            this.$message.warning(this.$t('wine.AvailableQty'));
                            return;
                        }

                        let invSku = {};
                        invSku.sku = item.sku
                        invSku.skuUom = item.skuUom
                        invSku.dudf01 = inv.dudf01,
                            invSku.dudf02 = inv.dudf02,
                            invSku.dudf03 = inv.dudf03,
                            invSku.locationCode = inv.locationCode,
                            invSku.lotId = inv.lotId,
                            invSku.imageUrl = inv.imageUrl,
                            invSku.orderQty = inv.orderQty,
                            newNonMerOrderDetails.push(invSku)
                    }
                }

                // 保存到数据库中
                if (newNonMerOrderDetails != null && newNonMerOrderDetails.length > 0) {
                    let params = {
                        nonMerOrderDetails: newNonMerOrderDetails,
                        currentStep: '1'
                    }

                    ajax.post(api.INVWINEADDTEMPORDERNONMER, params).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.msg)
                            // 重新刷新购物车
                            this.flushShopCart()
                            // 重置Item Order Qty = 0
                            for (let inv2 of item.invNonMerDudfList) {
                                for (let inv of inv2.skuOrderData) {
                                    inv.avBaseQty = inv.avBaseQty - inv.orderQty
                                    item.sumAvBaseQty = item.sumAvBaseQty - inv.orderQty
                                    inv.orderQty = 0
                                }
                            }
                            item.sumOrderQty = 0

                        } else {
                            this.$message.warning(res.msg);
                        }
                    })

                } else {
                    this.$message.warning(this.$t('wine.AvailableQty'));
                }

            },


            itemGoshopDetail2(item, detail) {
                let nonMerOrderDetails = [];
                // 需要加入购物车的对象
                if (detail == null) {
                    let avBaseQty = item.sumAvBaseQty
                    let orderQty = item.sumOrderQty
                    if (orderQty > avBaseQty) { // 数量超过可用数量
                        this.$message.warning(this.$t('wine.AvailableQty'));
                    }

                    let invList = item.invNonMerDudfList
                    let oldOrderQty = 0; // OrderQty 未来修改之前的数据
                    for (let inv2 of invList) {
                        for (let inv of inv2.skuOrderData) {
                            let qty = inv.orderQty == null ? 0 : inv.orderQty;
                            oldOrderQty += qty;
                        }
                    }

                    let needUpdateQty = orderQty - oldOrderQty; // 需要更新的量  needUpdateQty < 0  即要减少 ，needUpdateQty > 0 要加

                    if (needUpdateQty > 0) {

                        for (let inv of invList) {
                            let qty = inv.avBaseQty - inv.orderQty; // 该条明细需要 + 的数量
                            if (qty == 0) {
                                continue;
                            }
                            if (needUpdateQty == 0) {
                                break;
                            }
                            if (needUpdateQty >= qty) {
                                inv.orderQty = inv.avBaseQty
                                needUpdateQty = needUpdateQty - qty
                            } else {
                                inv.orderQty = inv.orderQty + needUpdateQty
                                needUpdateQty = 0;
                            }
                            let invSku = {};
                            invSku.sku = item.sku
                            invSku.skuUom = item.skuUom
                            invSku.dudf01 = inv.dudf01,
                                invSku.dudf02 = inv.dudf02,
                                invSku.dudf03 = inv.dudf03,
                                invSku.locationCode = inv.locationCode
                            invSku.orderQty = inv.orderQty
                            nonMerOrderDetails.push(invSku)
                        }

                    } else {
                        for (var i = invList.length - 1; i >= 0; i--) {

                            let inv = invList[i]
                            let qty = inv.orderQty == null ? 0 : inv.orderQty; // 该条明细能 减少 的数量
                            if (qty == 0) {
                                continue;
                            }
                            if (needUpdateQty == 0) {
                                break;
                            }

                            if (needUpdateQty + qty < 0) {
                                needUpdateQty = needUpdateQty + qty
                                inv.orderQty = 0
                                console.info(inv)

                            } else {
                                inv.orderQty = inv.orderQty + needUpdateQty
                                needUpdateQty = 0;

                            }
                            let invSku = {};
                            invSku.sku = item.sku
                            invSku.skuUom = item.skuUom
                            invSku.dudf01 = inv.dudf01,
                                invSku.dudf02 = inv.dudf02,
                                invSku.dudf03 = inv.dudf03,
                                invSku.locationCode = inv.locationCode
                            invSku.orderQty = inv.orderQty
                            nonMerOrderDetails.push(invSku)
                        }
                    }

                } else {
                    let invSku = {};
                    let avBaseQty = detail.avBaseQty
                    let orderQty = detail.orderQty

                    if (orderQty > avBaseQty) { // 数量超过可用数量
                        this.$message.warning(this.$t('wine.AvailableQty'));
                    }
                    invSku.dudf01 = detail.dudf01,
                        invSku.dudf02 = detail.dudf02,
                        invSku.dudf03 = detail.dudf03,
                        invSku.locationCode = detail.locationCode
                    invSku.orderQty = detail.orderQty
                    nonMerOrderDetails.push(invSku)
                }
                console.info(nonMerOrderDetails)













                //  // 保存到数据库中
                //     if(invSku != null){
                //         let params = {
                //             nonMerOrderDetails: [invSku],
                //             currentStep: '1'
                //         }
                //     //       this.$store.commit("updataLoading", { pbLoading: true });
                //         ajax.post(api.INVWINEADDTEMPORDERNONMER,params).then(res=>{
                //             // this.$store.commit("updataLoading", { pbLoading: false });
                //             if(res.code == 200){
                //                 // detail.avBaseQty = parseInt(detail.avBaseQty) -  parseInt(detail.orderQty)
                //                 // ajax.post(api.INVWINEFINDTEMPSOORDERINFO).then(res=>{
                //                 //     if(res.data.invTempDetailList != null){
                //                 //         this.gouwucheData  = res.data.invTempDetailList
                //                 //     }else{
                //                 //         this.gouwucheData = []
                //                 //     }
                //                 // })
                //                 // this.$message.success(res.msg);
                //                 // for(let i in this.tableList){
                //                 //     this.tableList[i].orderQty = 1
                //                 // }
                //             }else{
                //                 this.$message.warning(res.msg);
                //             }
                //         })
                //     }else{
                //         this.$message.warning(this.$t('wine.AvailableQty'));
                //     }





            },
            itemGoshopDetail(item) { // 加入购物车
                this.itemGoshopDetail2(item, null)
            },
            moment,
            //            分页satrt
            pageInit(type) {
                if (type == 'l') {
                    if (this.pageNum < 2) {
                        this.pageNum = 1
                    } else {
                        this.pageNum = parseInt(this.pageNum) - 1
                        this.init()
                    }
                } else {
                    if (this.pageNum < 1) {
                        this.pageNum = 1
                    } else {

                        this.pageNum = parseInt(this.pageNum) + 1
                        if (this.pageNum > this.totalFeshu) {
                            this.pageNum = parseInt(this.pageNum) - 1
                            return
                        }
                        this.init()
                    }
                }
            },
            pressEnter() {
                if (parseInt(this.pageNum) > this.totalFeshu || parseInt(this.pageNum) < 0 || parseInt(this.pageNum) ==
                    0) {
                    this.pageNum = this.targetPageNum
                } else {
                    this.init()
                }
            },
            pageSizeChange(val) {
                this.pageSize = parseInt(val.key)
                this.pageNum = 1
                this.init()
            },
            //            分页end
            //            删除
            resetStep() {
                let arr = []
                for (let i in this.tableList) {
                    const obj = {
                        "itemSize": this.tableList[i].itemSize,
                        "orderQty": this.tableList[i].orderQty,
                        "packageQty": this.tableList[i].packageQty,
                        "region": this.tableList[i].region,
                        "sku": this.tableList[i].sku,
                        "wineName": this.tableList[i].wineName,
                        "year": this.tableList[i].year,
                        "skuCode": this.tableList[i].skuCode,
                        "receivedTime": moment(this.tableList[i].receiveDate).format("YYYYMMDD")
                    }
                    arr.push(obj)
                }
                let params = {
                    deleteFlag: 0,
                    soDetail: arr
                }
                ajax.post(api.INVWINEADDTEMPORDER, params).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        this.tableList = []
                        this.searchTable()
                    } else {
                        this.$message.warning(res.msg);
                    }
                })
            },
            //            save 取消咯
            stepSave() {
                // let arr = []
                // let cacheArr = []
                // for (let i in this.tableList) {
                //     if (this.tableList[i].orderQty > 0) {
                //         const obj = {
                //             "itemSize": this.tableList[i].itemSize,
                //             "orderQty": this.tableList[i].orderQty,
                //             "packageQty": this.tableList[i].packageQty == '' ? 0 : this.tableList[i].packageQty,
                //             "region": this.tableList[i].region,
                //             "sku": this.tableList[i].sku,
                //             "wineName": this.tableList[i].wineName,
                //             "year": this.tableList[i].year,
                //             "skuCode": this.tableList[i].skuCode
                //         }
                //         arr.push(obj)
                //         cacheArr.push(this.tableList[i])
                //     }
                // }
                // if (arr.length == 0) {
                //     this.$message.warning('Please select your order item(s)');
                //     return
                // }
                // let params = {
                //     soDetail: arr,
                //     currentStep: '1'
                // }
                // ajax.post(api.INVWINEADDTEMPORDER, params).then(res => {
                //     if (res.code == 200) {
                //         this.$message.success(res.msg);
                //         this.$emit('emitValue', {
                //             type: 'step1',
                //             data: cacheArr
                //         })
                //     } else {
                //         this.$message.warning(res.msg);
                //     }
                // })
            },
            //            order Qty change 事件
            OrderQtyClick(v, detail, index) {
                console.info('7845')
                if (v.key == 10) {
                    detail.orderQtyFlag = false
                    this.$nextTick(() => {
                        let input = this.$refs.orderQtyinputNumberRefs[this.$refs.orderQtyinputNumberRefs
                            .length - 1].$el.children[1].children[0];
                        input.focus()
                        input.select()
                    })
                }
                detail.orderQty = v.key
            },
            //            放大图片
            enlargeImg(url){
                this.bigImgvis = true;
                this.bigImgUrl = url;
            },
            enlargeImgs(index){
                this.bigImgs = true;
                this.bigImgIndex = index;
            },
            leftPhotoXiao(item) {
                this.rightBigImg = item.photo
            },
            //            初始化数据
            init() {
                this.cartQty = 0
                let params = {}
                params = this.searchInfo
                this.spinning = true
                params.pageNum = this.pageNum
                params.pageSize = this.pageSize

                // 获取页面数据
                ajax.post(api.INVALLNONMER, params).then(res => {
                    this.targetPageNum = this.pageNum
                    this.spinning = false
                    if (res.code == 200) {
                        store.commit("updataLoading", { pbLoading: false });
                        this.totalRecords = res.totalRecords;
                        let invDatas = res.data // 所有的inv 数据   
                        // 页面显示数据
                        this.tableList = invDatas
                        this.totalFeshu = Math.ceil(parseInt(res.totalRecords) / this.pageSize)
                    }
                })
                this.flushShopCart()
            },
            flushShopCart() {
                // 获取购物车数据
                ajax.get(api.GETINVTEMPORDERNONMER).then(res => {
                    if (res.code == 200) {
                        // this.nonMerOrder.nonMerOrderDetails = res.data.nonMerOrderDetails;
                        // console.info(nonMerOrderDetails)
                        let nonMerOrderDetails = res.data.nonMerOrderDetails
                        if(nonMerOrderDetails == undefined || nonMerOrderDetails.length == null ){
                             this.nonMerOrder.nonMerOrderDetails = []
                             return;
                        }
                        let groupNonMerOrderDetails = [];
                        for (let item of nonMerOrderDetails) {
                            // console.info('8787')
                            let flag = true;
                            for (let detail of groupNonMerOrderDetails) {
                                if (detail.sku == item.sku && detail.skuUom == item.skuUom) {
                                    let skuInv = {}
                                    skuInv.dudf01 = item.dudf01
                                    skuInv.dudf02 = item.dudf02
                                    skuInv.dudf03 = item.dudf03
                                    skuInv.locationCode = item.locationCode
                                    skuInv.barcode = item.barcode
                                    skuInv.orderQty = item.orderQty
                                    detail.sumOrderQty = detail.sumOrderQty + item.orderQty
                                    detail.skuOrderData.push(skuInv)
                                    flag = false;
                                    break;
                                }
                            }
                            if (flag) {
                                let detail = {};
                                detail.imageUrl = item.imageUrl,
                                detail.sku = item.sku,
                                detail.skuDesc = item.skuDesc,
                                detail.skuUom = item.skuUom,
                                detail.sumOrderQty = item.orderQty == null ? 0 : item.orderQty
                                detail.skuOrderData = []
                                let skuInv = {}
                                skuInv.dudf01 = item.dudf01
                                skuInv.dudf02 = item.dudf02
                                skuInv.dudf03 = item.dudf03
                                skuInv.locationCode = item.locationCode
                                skuInv.barcode = item.barcode
                                skuInv.orderQty = item.orderQty
                                detail.skuOrderData.push(skuInv)
                                groupNonMerOrderDetails.push(detail)
                            }
                        }
                        this.nonMerOrder.nonMerOrderDetails = groupNonMerOrderDetails
                        this.cartQty = this.nonMerOrder.nonMerOrderDetails.length;
                    }
                })
            },


            //            搜索
            searchTable(val) {
                this.form.validateFields((err, values) => {
                    this.searchInfo = values
                    if (this.searchInfo.dateFm) {
                        this.searchInfo.dateFm = (this.searchInfo.dateFm).format("YYYYMMDD")
                    }
                    if (this.searchInfo.dateTo) {
                        this.searchInfo.dateTo = (this.searchInfo.dateTo).format("YYYYMMDD")
                    }
                    this.init()
                })
            },


            goTypeClick(type) {
                let nonMerOrderDetails = this.nonMerOrder.nonMerOrderDetails;
                if (type == 'Next') {
                    if (nonMerOrderDetails != null && nonMerOrderDetails != undefined && nonMerOrderDetails.length >
                        0) {
                        // this.$emit('emitValue',{type: 'nonMerStep1', data: this.gouwucheData})
                        this.$emit('goType', type)
                    } else {
                        this.$message.warning('Please select your order item(s)');
                    }
                }
            }
        }
    }
</script>
<style lang="less" scoped >
    .el-carousel__item h3 {
        color: #475669;
        font-size: 18px;
        opacity: 0.75;
        line-height: 138px;
        margin: 0;
        text-align: center;
    }



    .pageDisable2 {
        cursor: not-allowed;
    }

    #step1 {
        .list_Liquor {
            border-bottom: 1px solid #b8b8b8;
            padding: 6px 4px 6px 0;

            .list_Liquor_detail {
                flex: 1;
                margin-left: 10px;

                .list_Liquor_left {
                    .list_Liquor_title {
                        font-weight: 800;
                        font-weight: bold;
                        font-size: 14px;
                        margin-bottom: 10px;
                        width: 100px;
                        word-wrap: normal;
                    }
                }

                .list_Liquor_Right {
                    color: #707070;
                    float: right;
                    text-align: right;

                    .list_Liquor_Right_T {
                        margin-bottom: 32px;
                    }

                    .list_Liquor_Right_Lebal_L {
                        width: 180px;
                        text-align: rigth;
                    }

                    .list_Liquor_Right_Lebal {
                        font-size: 15px;
                        font-weight: bold;
                    }
                }
            }
        }
    }
    /*明细出场动画*/
    .v-enter,.v-leave-to{
        opacity: 0;
        transform: translateY(50%);
    }
    .v-enter-active,
    .v-leave-active{
        transition: all 0.5s ease;
    }
</style>